export default "__VITE_ASSET__V1RB_EuQ__"